import React from 'react'
import { Typography, LottieImage } from '..'
import missingImage from "../../../utils/Missing files.json"
import propTypes from "prop-types"

const CustomNoRowsOverlay = ({ noRowsMessageFunc = () => null }) => {
    return (
        <div>
            {missingImage && <LottieImage comingsoonImg={"true"} style={{ height: '7rem' }} src={missingImage} />}
            <Typography variant="xl" className="font-semibold" text={noRowsMessageFunc()} />
            <Typography variant="base" text="Try searching for something else." />
        </div>
    )
}

export default React.memo(CustomNoRowsOverlay) 

CustomNoRowsOverlay.propTypes ={ 
    noRowsMessageFunc: propTypes.func
}